import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.model';

export const CONST = {
  HEADER: $localize`New Security Screening`,
  SCREENING_TYPE: $localize`Screening Type`,
  TRACKING_NUMBER: $localize`Tracking Number`,
  SCREENING_METHOD: $localize`Screening Method`,
  SCREENER_ID: $localize`Screener ID`,
  SORT_DATE: $localize`Sort Date`,
  SORT_CODE: $localize`Sort Code`,
  SECONDARY_SCREENING: $localize`Secondary Screening`,
  CANCEL: $localize`Cancel`,
  SUBMIT: $localize`Submit`,
  ENTER_ID: $localize`Enter ID`,
  ENTER_TRACKING_NUMBER: $localize`Enter Tracking Number`,
  SECONDARY_SCREENING_METHOD: $localize`Secondary Screening Method`,
  CLOSE_MODAL: $localize`Close Window`,
  BODY: $localize`Your changes will not be saved.`,
  CONFIRM_BUTTON: $localize`Yes`,
  REJECT_BUTTON: $localize`No`,
  CANCEL_MODAL: $localize`Cancel?`,
};

export const SCREENING_TYPE_OPTION: IOption[] = [
  {
    label: $localize`SEC SCR 1`,
    value: $localize`SEC SCR 1`,
  },
  {
    label: $localize`SEC SCR 2`,
    value: $localize`SEC SCR 2`,
  },
  {
    label: $localize`COMM VERIF`,
    value: $localize`COMM VERIF`,
  },
];
export const COMMON_SCREENING_METHOD_OPTION: IOption[] = [
  {
    label: $localize`XR3: MANUAL X-RAY`,
    value: $localize`XR3: MANUAL X-RAY`,
  },
  {
    label: $localize`PHS: HAND SEARCH`,
    value: $localize`PHS: HAND SEARCH`,
  },
  {
    label: $localize`AOM: ANY OTHER MEANS`,
    value: $localize`AOM: ANY OTHER MEANS`,
  },
];

export const SCREENING_METHOD_OPTION: IOption[] = [
  {
    label: $localize`XR3: MANUAL X-RAY`,
    value: $localize`XR3: MANUAL X-RAY`,
  },
  {
    label: $localize`ETD: EXPLOSIVE TRACE`,
    value: $localize`ETD: EXPLOSIVE TRACE`,
  },
  {
    label: $localize`PHS: HAND SEARCH`,
    value: $localize`PHS: HAND SEARCH`,
  },
  {
    label: $localize`XR2: TIMED X-RAY`,
    value: $localize`XR2: TIMED X-RAY`,
  },
  {
    label: $localize`EDS: FULLAUTO XRAY`,
    value: $localize`EDS: FULLAUTO XRAY`,
  },
  {
    label: $localize`EDD: EXPLOS DET DOGS`,
    value: $localize`EDD: EXPLOS DET DOGS`,
  },
  {
    label: $localize`VCK: VISUAL CHECK`,
    value: $localize`VCK: VISUAL CHECK`,
  },
  {
    label: $localize`AOM: ANY OTHER MEANS`,
    value: $localize`AOM: ANY OTHER MEANS`,
  },

  {
    label: $localize`CMD: CARGO METAL DET`,
    value: $localize`CMD: CARGO METAL DET`,
  },
  {
    label: $localize`TRN: TRANSSHIPMENT`,
    value: $localize`TRN: TRANSSHIPMENT`,
  },
  {
    label: $localize`DIP: DIPLOMATIC MAIL`,
    value: $localize`DIP: DIPLOMATIC MAIL`,
  },
  {
    label: $localize`BIO: BIOMEDICAL`,
    value: $localize`BIO: BIOMEDICAL`,
  },
  {
    label: $localize`LFS: LIFESAVINGMATRL`,
    value: $localize`LFS: LIFESAVINGMATRL`,
  },
  {
    label: $localize`MAI: EXEMPT MAIL`,
    value: $localize`MAI: EXEMPT MAIL`,
  },
  {
    label: $localize`IAC: INDIRECT AIR CARRIER`,
    value: $localize`IAC: INDIRECT AIR CARRIER`,
  },
];

export const SORT_CODE_OPTION: IOption[] = [
  {
    label: $localize`L1`,
    value: $localize`L1`,
  },
  {
    label: $localize`L2`,
    value: $localize`L2`,
  },
];
